// TypingIndicator.jsx
import React from 'react';

const TypingIndicator = ({ isTyping, senderPlayerId, variant, players = [] }) => {
  if (variant === 'radio') {
    const label = players.length === 1 ? `${players[0]} is typing` : players.length === 2
      ? `${players[0]} and ${players[1]} are typing` : players.length > 2 ? `${players.length} people are typing` : '';
    return <div className="radio-typing-indicator" role="status" aria-live="polite" aria-atomic="true">
      {label && <><span className="radio-typing-dots" aria-hidden="true"><i /><i /><i /></span>
        <span className="radio-typing-label" title={label}>{label}</span></>}
    </div>;
  }
  if (!isTyping || !senderPlayerId) {
    return null;
  }

  return <span>{senderPlayerId} is typing...</span>;
};

export default TypingIndicator;
